import React from "react";
import { Select, Form } from "antd";

const { Option } = Select;

const FilterCheckbox = ({ filter }) => {
  return (
    <Form.Item name={filter.name}>
      <Select
        placeholder="Selecione"
        showSearch
        mode={filter.multiple && "multiple"}
      >
        {Object.values(filter.values)?.map((option) => (
          <Option key={option.value} value={option.value}>
            {option.label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};

export default FilterCheckbox;
